import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { H3Text } from '@prisjakt/ui/text/variants';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import UserReviewPrompt from '../../areas/reviews/components/prompt';

const meterHeight = '6px';

export const StyledUserReviewPrompt = styled(UserReviewPrompt)`
  width: 100%;
`;
export const RatingDistributionContainer = styled.div`
  flex: 1;
`;
export const RatingContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 270px;
  flex: 0;
  margin: 0 auto;
`;

export const Summary = styled.div`
  color: ${p => p.theme.text.quaternary};
  margin-bottom: ${layout.measurements.spacing100};
`;

export const Distribution = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: ${layout.measurements.spacing050};
  row-gap: ${layout.measurements.spacing050};
  align-items: center;
  margin-top: ${layout.measurements.spacing050};
`;
interface ISummaryWrapper {
  columnView: boolean;
}
export const SummaryWrapper = styled.div<ISummaryWrapper>`
  ${props => css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: ${layout.measurements.spacing050};

    ${props.columnView &&
      css`
        ${media.mediumUp`
          gap: ${layout.measurements.spacing300};
          flex-direction: row;
        `}
      `}
  `}
`;

export const Meter = styled.div`
  height: ${meterHeight};
  background: ${p => p.theme.lines.primary};
  border-radius: ${meterHeight};
`;

type IndicatorProps = {
  width: string;
};

export const Indicator = styled.div<IndicatorProps>`
  width: ${p => p.width};
  height: 100%;
  background: ${p => p.theme.lines.highlight};
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`;

export const MeterLabel = styled.span`
  white-space: nowrap;
  font-weight: 600;
  display: flex;
  align-items: center;
  column-gap: 4px;
  color: ${p => p.theme.text.primary};
`;

export const MeterCount = styled.span`
  color: ${p => p.theme.text.quaternary};
  font-size: ${layout.measurements.fontSizeSmall};
`;

export const Score = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  font-size: 24px;
  color: ${p => p.theme.text.primary};
  margin-left: ${layout.measurements.spacing050};
  margin-right: ${layout.measurements.spacing025};
`;

export const PromptButton = styled(PrimaryButton)`
  margin-bottom: ${layout.measurements.spacing150};
`;

export const Title = styled(H3Text)`
  margin-bottom: ${layout.measurements.spacing050};
`;

export const StarRate = styled.span`
  line-height: 1;
  margin-right: ${layout.measurements.spacing025};
`;
